(() => {
  if(customElements.get('sz-product-shelf'))return;
  customElements.define('sz-product-shelf',class extends HTMLElement {
    connectedCallback(){
      this.track=this.querySelector('.sz-shelf-track');if(!this.track)return;
      this.abort?.abort();this.abort=new AbortController();const options={signal:this.abort.signal};
      const buttons=[...this.querySelectorAll('[data-direction]')];
      this.update=()=>{const end=this.track.scrollWidth-this.track.clientWidth;buttons.forEach(b=>{b.hidden=end<=2;b.disabled=Number(b.dataset.direction)<0?this.track.scrollLeft<=2:this.track.scrollLeft>=end-2;});};
      this.move=direction=>this.track.scrollBy({left:direction*this.track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      buttons.forEach(b=>b.addEventListener('click',()=>this.move(Number(b.dataset.direction)),options));
      this.track.addEventListener('scroll',this.update,{...options,passive:true});
      this.track.addEventListener('keydown',e=>{if(e.target===this.track&&['ArrowLeft','ArrowRight'].includes(e.key)){e.preventDefault();this.move(e.key==='ArrowLeft'?-1:1);}},options);
      this.resize=new ResizeObserver(this.update);this.resize.observe(this.track);this.update();
    }
    disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();}
  });
})();
